import {
  GET_AGGR_GROUP_BY_TAGS_DATA_SUCCESS,
  GET_AGGR_TAGS_DATA,
  GET_AGGR_TAGS_DATA_ERROR,
  GET_AGGR_TAGS_DATA_SUCCESS,
  GET_API_DATA_BY_ID,
  GET_API_DATA_BY_ID_ERROR,
  GET_API_DATA_BY_ID_SUCCESS,
  GET_API_TIMINGS_DATA,
  GET_API_TIMINGS_DATA_ERROR,
  GET_API_TIMINGS_DATA_SUCCESS,
  EXPORT_API_TIMINGS_DATA,
  EXPORT_API_TIMINGS_DATA_SUCCESS,
  EXPORT_API_TIMINGS_DATA_ERROR,
  GET_PROFILING_TAGS, GET_PROFILING_TAGS_ERROR, GET_PROFILING_TAGS_SUCCESS,
  GET_DMS_LOGS_STREAMS,
  GET_DMS_LOGS_STREAMS_SUCCESS,
  GET_DMS_LOGS_STREAMS_ERROR,
  GET_DMS_STATS_DATA,
  GET_DMS_STATS_DATA_SUCCESS,
  GET_DMS_STATS_DATA_ERROR,
  GET_DMS_LOGS_DATA,
  GET_DMS_LOGS_DATA_SUCCESS,
  GET_DMS_LOGS_DATA_ERROR,
  GET_RULE_NAMES,
  GET_RULE_NAMES_ERROR,
  GET_RULE_NAMES_SUCCESS,
  GET_RULE_LOGS_SUCCESS,
  GET_RULE_LOGS_ERROR,
  GET_RULE_LOGS,
  GET_RULE_STATS,
  GET_RULE_STATS_ERROR,
  GET_RULE_STATS_SUCCESS,
  GET_PRODUCTS_NAMES_SUCCESS,
  GET_PRODUCTS_NAMES_ERROR,
  GET_PRODUCTS_NAMES,
  GET_ACCOUNTS_LIST,
  GET_ACCOUNTS_LIST_SUCCESS,
  GET_ACCOUNTS_LIST_ERROR,
  GET_RULE_LOG_DETAILS,
  GET_RULE_LOG_DETAILS_SUCCESS,
  GET_RULE_LOG_DETAILS_ERROR,
} from './actionTypes';
import {
  API_TIMINGS_PAGINATION_OPTIONS,
  handleGetCampaignFulfillment,
  handleGetCampaignFulfillmentError,
  handleGetCampaignFulfillmentSuccess,
} from 'helpers/campaign_fulfillment_pagination_helper';

const DEFAULT_LOOKAHEAD_PAGES = 8;

const INIT_STATE = {
  profiling_tags: [],
  profiling_tags_loading: false,
  profiling_tags_error: null,
  aggr_tags_data_loading: false,
  aggr_tags_data: {},
  aggr_tags_data_error: null,
  aggr_group_by_tags: [],
  aggr_group_by_tags_loading: false,
  api_timings_data: [],
  api_timings_data_loading: false,
  api_timings_export_loading: false,
  api_timings_data_error: null,
  last_page_fetched: 0,
  has_next_page: false,
  has_lookahead_pages: false,
  total_number_of_pages: 0,
  active_cache_key: null,
  page_cache: {},
  last_fetched_at: null,
  api_timing_data_by_id: {},
  api_timing_data_by_id_loading: false,
  last_fetched_api_timing_data_id: null,
  dms_logs_streams: [],
  dms_logs_streams_loading: false,
  dms_logs_streams_error: null,
  dms_stats_data: [],
  dms_stats_data_loading: false,
  dms_stats_data_error: null,
  dms_logs_data: [],
  dms_logs_data_loading: false,
  dms_logs_data_error: null,
  dms_logs_data_last_page_fetched: 0,
  dms_logs_data_has_next_page: false,
  dms_logs_data_total_number_of_pages: 0,
  dms_logs_data_has_lookahead_pages: false,
  dms_logs_data_lookahead_pages: 0,
  rule_names: [],
  rule_names_loading: false,
  rule_names_error: null,
  rule_logs: [],
  rule_logs_loading: false,
  rule_logs_error: null,
  rule_logs_last_page_fetched: 0,
  rule_logs_has_next_page: false,
  rule_logs_total_number_of_pages: 0,
  rule_logs_has_lookahead_pages: false,
  rule_logs_lookahead_pages: 0,
  rule_stats: [],
  rule_stats_loading: false,
  rule_stats_error: null,
  product_names: [],
  product_names_loading: false,
  product_names_error: null,
  accounts_list: [],
  accounts_list_loading: false,
  accounts_list_error: null,
  rule_log_details: [],
  rule_log_details_loading: false,
  rule_log_details_error: null,
}

const DevDashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROFILING_TAGS:
      return {
        ...state,
        profiling_tags_loading: true
      };

    case GET_PROFILING_TAGS_SUCCESS:
      return {
        ...state,
        profiling_tags: action.payload,
        profiling_tags_loading: false
      };

    case GET_PROFILING_TAGS_ERROR:
      return {
        ...state,
        profiling_tags_error: action.payload,
        profiling_tags_loading: false,
      };
    case GET_AGGR_TAGS_DATA:
      let loading = 'aggr_tags_data_loading'
      if (action.payload?.group_by_tag == "1") {
        loading = 'aggr_group_by_tags_loading'
      }
      return {
        ...state,
        [loading]: true
      }
    case GET_AGGR_TAGS_DATA_SUCCESS:
      return {
        ...state,
        aggr_tags_data_loading: false,
        aggr_tags_data: action.payload
      }
    case GET_AGGR_GROUP_BY_TAGS_DATA_SUCCESS:
      return {
        ...state,
        aggr_group_by_tags: action.payload,
        aggr_group_by_tags_loading: false
      }
    case GET_AGGR_TAGS_DATA_ERROR:
      return {
        ...state,
        aggr_tags_data_loading: false,
        aggr_group_by_tags_loading: false,
        aggr_group_by_tags: [],
        aggr_tags_data: [],
        aggr_tags_data_error: action.payload
      }
    case GET_API_TIMINGS_DATA:
      return handleGetCampaignFulfillment(state, action, 'api_timings_data', API_TIMINGS_PAGINATION_OPTIONS)
    case GET_API_TIMINGS_DATA_SUCCESS:
      return handleGetCampaignFulfillmentSuccess(state, action, 'api_timings_data', API_TIMINGS_PAGINATION_OPTIONS)
    case GET_API_TIMINGS_DATA_ERROR:
      return handleGetCampaignFulfillmentError(state, action, 'api_timings_data', API_TIMINGS_PAGINATION_OPTIONS)
    case EXPORT_API_TIMINGS_DATA:
      return {
        ...state,
        api_timings_export_loading: true,
        api_timings_data_error: null,
      }
    case EXPORT_API_TIMINGS_DATA_SUCCESS:
      return {
        ...state,
        api_timings_export_loading: false,
      }
    case EXPORT_API_TIMINGS_DATA_ERROR:
      return {
        ...state,
        api_timings_export_loading: false,
        api_timings_data_error: action.payload,
      }
    case GET_API_DATA_BY_ID:
      return {
        ...state,
        api_timing_data_by_id_loading: true
      }
    case GET_API_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        api_timing_data_by_id_loading: false,
        api_timing_data_by_id: action.payload?.[0],
        last_fetched_api_timing_data_id: action.payload?.[0]?.id
      }
    case GET_API_DATA_BY_ID_ERROR:
      return {
        ...state,
        api_timing_data_by_id_loading: false,
        api_timing_data_by_id: {}
      }
    case GET_DMS_LOGS_STREAMS:
      return {
        ...state,
        dms_logs_streams_loading: true
      }
    case GET_DMS_LOGS_STREAMS_SUCCESS:
      return {
        ...state,
        dms_logs_streams_loading: false,
        dms_logs_streams: action.payload
      }
    case GET_DMS_LOGS_STREAMS_ERROR:
      return {
        ...state,
        dms_logs_streams_loading: false,
        dms_logs_streams_error: action.payload
      }
    case GET_DMS_STATS_DATA:
      return {
        ...state,
        dms_stats_data_loading: true
      }
    case GET_DMS_STATS_DATA_SUCCESS:
      return {
        ...state,
        dms_stats_data_loading: false,
        dms_stats_data: action.payload
      }
    case GET_DMS_STATS_DATA_ERROR:
      return {
        ...state,
        dms_stats_data_loading: false,
        dms_stats_data_error: action.payload
      }
    case GET_DMS_LOGS_DATA:
      return {
        ...state,
        dms_logs_data_loading: true,
      }
    case GET_DMS_LOGS_DATA_SUCCESS:
      const dmsAdditional = action.payload?.additional_data || {}
      const dmsHasLookaheadPages = Boolean(dmsAdditional?.has_lookahead_pages)
      return {
        ...state,
        dms_logs_data_loading: false,
        dms_logs_data: action.payload?.data || [],
        dms_logs_data_last_page_fetched: parseInt(dmsAdditional?.page_number) || 1,
        dms_logs_data_has_next_page: Boolean(dmsAdditional?.has_next_page),
        dms_logs_data_total_number_of_pages: parseInt(dmsAdditional?.total_number_of_pages) || 0,
        dms_logs_data_has_lookahead_pages: dmsHasLookaheadPages,
        dms_logs_data_lookahead_pages: dmsHasLookaheadPages ? (parseInt(dmsAdditional?.lookahead_pages) || DEFAULT_LOOKAHEAD_PAGES) : 0,
      }
    case GET_DMS_LOGS_DATA_ERROR:
      return {
        ...state,
        dms_logs_data_loading: false,
        dms_logs_data_error: action.payload,
        dms_logs_data_has_next_page: false,
        dms_logs_data_has_lookahead_pages: false,
        dms_logs_data_lookahead_pages: 0,
      }
    case GET_RULE_NAMES:
      return {
        ...state,
        rule_names: action.payload,
        rule_names_loading: true
      }
    case GET_RULE_NAMES_SUCCESS:
      return {
        ...state,
        rule_names: action.payload,
        rule_names_loading: false
      }
    case GET_RULE_NAMES_ERROR:
      return {
        ...state,
        rule_names: [],
        rule_names_loading: false,
        rule_names_error: action.payload
      }
    case GET_ACCOUNTS_LIST:
      return {
        ...state,
        accounts_list: action.payload,
        accounts_list_loading: true
      }
    case GET_ACCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        accounts_list: action.payload,
        accounts_list_loading: false
      }
    case GET_ACCOUNTS_LIST_ERROR:
      return {
        ...state,
        accounts_list: action.payload,
        accounts_list_loading: false,
        accounts_list_error: action.payload
      }
    case GET_RULE_LOGS:
      return {
        ...state,
        rule_logs_loading: true
      }
    case GET_RULE_LOGS_SUCCESS:
      const ruleAdditional = action.payload?.additional_data || {}
      const ruleHasLookaheadPages = Boolean(ruleAdditional?.has_lookahead_pages)
      return {
        ...state,
        rule_logs: action.payload?.data || [],
        rule_logs_loading: false,
        rule_logs_last_page_fetched: parseInt(ruleAdditional?.page_number) || 1,
        rule_logs_has_next_page: Boolean(ruleAdditional?.has_next_page),
        rule_logs_total_number_of_pages: parseInt(ruleAdditional?.total_number_of_pages) || 0,
        rule_logs_has_lookahead_pages: ruleHasLookaheadPages,
        rule_logs_lookahead_pages: ruleHasLookaheadPages ? (parseInt(ruleAdditional?.lookahead_pages) || DEFAULT_LOOKAHEAD_PAGES) : 0,
      }
    case GET_RULE_LOGS_ERROR:
      return {
        ...state,
        rule_logs: [],
        rule_logs_loading: false,
        rule_logs_error: action.payload,
        rule_logs_has_next_page: false,
        rule_logs_has_lookahead_pages: false,
        rule_logs_lookahead_pages: 0,
      }
    case GET_RULE_STATS:
      return {
        ...state,
        rule_stats: action.payload,
        rule_stats_loading: true
      }
    case GET_RULE_STATS_SUCCESS:
      return {
        ...state,
        rule_stats: action.payload,
        rule_stats_loading: false
      }
    case GET_RULE_STATS_ERROR:
      return {
        ...state,
        rule_stats: [],
        rule_stats_loading: false,
        rule_stats_error: action.payload
      }
    case GET_PRODUCTS_NAMES:
      return {
        ...state,
        product_names: action.payload,
        product_names_loading: true
      }
    case GET_PRODUCTS_NAMES_SUCCESS:
      return {
        ...state,
        product_names: action.payload,
        product_names_loading: false
      }
    case GET_PRODUCTS_NAMES_ERROR:
      return {
        ...state,
        product_names: [],
        product_names_loading: false,
        product_names_error: action.payload
      }
    case GET_RULE_LOG_DETAILS:
      return {
       ...state,
        rule_log_details: [],
        rule_log_details_loading: true
      }
    case GET_RULE_LOG_DETAILS_SUCCESS:
      return {
       ...state,
        rule_log_details: JSON.parse(action.payload),
        rule_log_details_loading: false
      }
    case GET_RULE_LOG_DETAILS_ERROR:
      return {
       ...state,
        rule_log_details: [],
        rule_log_details_loading: false,
        rule_log_details_error: action.payload
      }
    default:
      return state;
  }
};

export default DevDashboard;
